import {DropdownMenu, type IconName} from '@wandb/components';

import {shellPathForRemotePath, type RouteClaimTable} from '../routeClaims';

export type HeaderLinkProps = {
  label: string;
  path: string;
  icon: IconName;
  routeClaims: RouteClaimTable;
  onAction: () => void;
};

export const HeaderLink = ({
  label,
  path,
  icon,
  routeClaims,
  onAction,
}: HeaderLinkProps) => {
  const shellHref = shellPathForRemotePath(routeClaims, 'wandb', path);
  return (
    <DropdownMenu.Item key={label} href={shellHref ?? path} onAction={onAction}>
      <DropdownMenu.ItemDecorationLeft iconProps={{icon}} />
      <DropdownMenu.ItemLabel>{label}</DropdownMenu.ItemLabel>
    </DropdownMenu.Item>
  );
};
